'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { useTheme } from 'styled-components';
import { TypeStyle } from '../TypeStyle';
function getBadgeColors(theme, colorVariant) {
    switch (colorVariant) {
        case 'primary':
            return {
                backgroundColor: theme.color.button.primary.fill.on.background,
                borderColor: theme.color.button.primary.border.on.background,
                color: theme.color.button.primary.content.on.background,
            };
        case 'secondary':
            return {
                backgroundColor: theme.color.button.secondary.fill.on.background,
                borderColor: theme.color.button.secondary.border.on.background,
                color: theme.color.button.secondary.content.on.background,
            };
        case 'neutral':
            return {
                backgroundColor: theme.color.button.tertiary.fill.on.background,
                borderColor: theme.color.button.tertiary.border.on.background,
                color: theme.color.button.tertiary.content.on.background,
            };
        case 'critical':
            return {
                backgroundColor: theme.color.fill.critical.subtle,
                borderColor: theme.color.fill.critical.subtle,
                color: theme.color.stroke.critical.text.on.subtle,
            };
        case 'celebratory':
            return {
                backgroundColor: theme.color.fill.celebratory.strong,
                borderColor: theme.color.fill.celebratory.strong,
                color: theme.color.stroke.neutral.text.primary.on.strong,
            };
        case 'caution':
            return {
                backgroundColor: theme.color.fill.caution.subtle,
                borderColor: theme.color.fill.caution.subtle,
                color: theme.color.stroke.caution.text.on.subtle,
            };
        case 'default':
        default:
            return {
                backgroundColor: theme.color.button.tertiary.fill.on.background,
                borderColor: theme.color.button.tertiary.border.on.background,
                color: theme.color.button.tertiary.content.on.background,
            };
    }
}
const sizeConfig = {
    small: {
        padding: {
            default: '4px 10px',
            label: '7px 12px',
        },
    },
    medium: {
        padding: {
            default: '6px 12px',
            label: '8px 16px',
        },
    },
    large: {
        padding: {
            default: '8px 16px',
            label: '10px 20px',
        },
    },
};
const getTypeStyleForSize = (size) => {
    switch (size) {
        case 'small':
            return TypeStyle.BodyTiny;
        case 'medium':
            return TypeStyle.BodyNano;
        case 'large':
            return TypeStyle.BodyMicro;
        default:
            return TypeStyle.BodyNano;
    }
};
const StyledBadge = styled.div `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${o => o.theme.spacing(2)};
  box-sizing: border-box;
  text-align: center;
  padding: ${({ $variant, $size }) => {
    const config = sizeConfig[$size];
    return $variant === 'label' ? config.padding.label : config.padding.default;
}};
  border-radius: ${({ $variant }) => ($variant === 'pill' ? '20px' : '4px')};
  border: 1px solid ${({ $variantColors }) => $variantColors.borderColor};
  background-color: ${({ $variantColors }) => $variantColors.backgroundColor};
  color: ${({ $variantColors }) => $variantColors.color};
`;
export const Badge = ({ variant = 'badge', size = 'medium', colorVariant = 'default', textTransform = 'uppercase', fontWeight = '600', children, as, ...rest }) => {
    const theme = useTheme();
    const variantColors = getBadgeColors(theme, colorVariant);
    const Component = as || getTypeStyleForSize(size);
    return (_jsx(StyledBadge, { as: Component, "$variant": variant, "$size": size, "$colorVariant": colorVariant, "$variantColors": variantColors, textTransform: textTransform, fontWeight: fontWeight, ...rest, children: children }));
};
//# sourceMappingURL=Badge.js.map